<template>
    <div class="about-box">
        <img class="about-selfesthe-img" src="./img/about-selfesthe.png" alt="セルフエステについて">
        <div class="about-selfesthe-content-box">
          <!--<div class="about-whiteback"></div>-->
          <!--<div class="about-selfesthe-text-box">
            <p class="about-text-main">セルフエステエンリケとは</p>-->
             <img src="./img/business-topic.png" class="topic-img-1" alt="">
          <div class="about-text-box">
            <p class="about-text-sub">
              安い・早い・手軽・即効<br>
              全てが叶うエステサロンです！
            </p>
          <!--</div>-->
            <ButtonReadMore class="about-selfeshte-button mg-bt-1em" linkPath="./about"></ButtonReadMore>
          </div>
        </div>
    </div>
</template>

<script>
import ButtonReadMore from '../../components/ButtonReadMore.vue'

export default {
  name: 'AboutBusiness',
  components:{
    ButtonReadMore,
  }
}
</script>

<style scope>
  .w-100-per{
    width: 100%;
  }

  .mg-bt-1em{
    margin: 1em 0;
  }

  /* PC表示 */
  @media screen and (min-width:821px){
    
    .topic-img-1{
      width:80%;
      padding-top:5vw;
    }

    .disp-pc{
      display: block;
    }

    .about-box{
      display:flex;
      align-content: center;
    }

    .about-selfesthe-img{
      width: 55vw;
      height: auto;
      object-fit: contain;
    }

    .about-selfesthe-text-box{
      width: 100%;
    }

    .about-selfesthe-content-box{
      color: white;
      background-color: var(--main-color);
      letter-spacing: 0.2em;
      text-align: center;
      justify-content: center;
      align-items: center;

      width: 45vw;
      height: auto;

      /*display: flex;*/
      /*flex-wrap: wrap;*/

      margin: 2% auto;
    }

    .about-text-main{
      font-size:26px;
      margin: 50px auto;
    }

    .about-text-sub{
      min-width:60%;
      font-size:18px;
      margin: 38px auto;
      margin-bottom:30px;
      line-height: 1.6em;
    }

    .about-selfeshte-button{
      width:50%;
      margin:0 auto;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .about-box{
      display:flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
    }

    .about-text-box{
      display:flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
    }

    .topic-img-1{
      width:70%;
      margin:0 auto;
      margin-top:20px;
    }

    .about-selfesthe-img{
      /*width: 70vw;
      height: auto;
      object-fit: contain;
      margin-bottom: 30px;*/
      display: none;
    }

    .about-selfesthe-text-box{
      width: auto;
      /*margin-right: 20px;
      left: 0;*/
    }

    .about-selfesthe-content-box{
      color: white;
      background-color: var(--main-color);

      text-align: center;

      width: 100vw;
      height: auto;

      display: flex;
      /*justify-content: center;*/
      align-items: center;

      flex-wrap: wrap;

      margin: 0 auto;
      /*
      padding:50px 0; */
    } 

    .about-text-main{
      font-size: 4vw;
      font-weight: 600;
      /*margin: 20px auto;*/
      margin-top:20px;
      margin-bottom:324x;
      color:var(--main-color);

      background:#fff;
      padding:10px 15px;
      /*padding-left: 20px;*/

      

    }

    .about-text-sub{
      font-size: 3vw;
      /*  ↓ここweight追加  */
      font-weight:600;
      margin: 20px auto;
      line-height: 2em;

    }

    .about-selfeshte-button{
      width: 35%;
      padding-top:10px;
      padding-right:20px;
      

    }
  }
</style>